import { render, staticRenderFns } from "./SupplementsSelector.vue?vue&type=template&id=30222675&scoped=true&"
import script from "./SupplementsSelector.vue?vue&type=script&lang=js&"
export * from "./SupplementsSelector.vue?vue&type=script&lang=js&"
import style0 from "./SupplementsSelector.vue?vue&type=style&index=0&id=30222675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30222675",
  null
  
)

export default component.exports